<template>
    <div>
        <div :class="[popupClass]">
            <div :class="[wrapClass]">
                <div class="title"> <span class="t01">{{ facilityNm }}</span> </div>
                <div class="text" v-if="typeof facilityInfo.facItemNm !== $_TYPE.UNDEF">
                    <span class="pop_bt_state red">{{ facilityInfo.facItemNm }}</span>
                    <span>{{ facilityAddr }}</span>
                </div>

                <div class="pop_table03" v-show="dispFacilityCols.length > 0">
                    <table>
                        <caption>시설리스트</caption>
                        <colgroup>
                            <col style="width: 40%;">
                            <col style="width: 60%;">
                        </colgroup>
                        <tbody>
                        <tr style="display: none;">
                            <th></th>
                            <td></td>
                        </tr>
                        <tr v-if="facRegDt !== ''">
                            <th>조사일</th>
                            <td>{{ facRegDt | ymd }}</td>
                        </tr>
                        <tr v-for="col in dispFacilityCols" :key="col.dataKdHdngSqno"
                            v-if="showCols(facilityInfo[col.dataHdngColnm])">
                            <th>{{ col.scrnHdngnm }}</th>
                            <td v-html="$options.filters.newLineToBr(facilityInfo[col.dataHdngColnm]) + col.untMknm"></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="photo memewe" v-if="facImgUrl !== ''"><img :src="facImgUrl" alt=""></div>

                <div class="pop_bt_close2"><a href="javascript: void(0);" class="self-close-btn">닫기</a></div>
            </div>
        </div>
    </div>
</template>

<script>
import commonApi from "@/apis/common.api";
import { mapGetters } from "vuex";
import { $_TYPE, $_WC } from "@/confs/common.const.js";

export default {
    data() {
        return {
            facilityInfo: {},
            facilityCols: [],
        };
    },
    props: {
        popupClass: {
            type: String,
            default: 'popup_st21'
        },
        wrapClass: {
            type: String,
            default: 'popup_wrap'
        },
    },
    computed: {
        dispFacilityCols() {
            if(typeof this.facilityCols !== $_TYPE.UNDEF) {
                let facilityCols = this.facilityCols.filter((facilityCol)=>{
                    return facilityCol.scrnHdngnm != '' &&
                        facilityCol.dataHdngnm != 'LAT' &&
                        facilityCol.dataHdngnm != 'LONG' &&
                        facilityCol.scrnDispSq > 0 &&
                        facilityCol.dataHdngnm != 'FAC_NAME' &&
                        facilityCol.dataHdngnm != 'FAC_ADDR' &&
                        facilityCol.dataHdngnm != 'FAC_IMG_URL' &&
                        facilityCol.dataHdngnm != 'FAC_ADDR_SUB' &&
                        facilityCol.dataHdngnm != 'FAC_REG_DT' &&
                        typeof this.facilityInfo[facilityCol.dataHdngColnm] !== $_TYPE.UNDEF &&
                        this.facilityInfo[facilityCol.dataHdngColnm] !== '" "' &&
                        this.facilityInfo[facilityCol.dataHdngColnm] !== '';
                });

                // 코드 -> 텍스트 변환으로 추가
                facilityCols.forEach((col)=>{
                    if(typeof col.untMknm === $_TYPE.UNDEF || col.untMknm === null) {
                        col.untMknm = '';
                    }
                    if(col.dataDsc === 'code' && col.dataHdngColnm.indexOf('valNm') === -1) {
                        let dataHdngColnm = col.dataHdngColnm;
                        let nm = dataHdngColnm.substring(3);
                        col.dataHdngColnm = 'valNm' + nm;
                    }
                });
                return facilityCols;
            }
        },
        facilityNm(){
            let facilityCols = this.facilityCols;
            let facNm = '';
            if(typeof facilityCols !== $_TYPE.UNDEF) {
                for(let i = 0; i < facilityCols.length; i++) {
                    if(facilityCols[i].dataHdngnm === 'FAC_NAME') {
                        if(typeof facilityCols[i].dataDsc !== $_TYPE.UNDEF &&  facilityCols[i].dataDsc === 'code') {
                            let nm = facilityCols[i].dataHdngColnm.substring(3);
                            facNm = this.facilityInfo['valNm' + nm];
                        } else {
                            if(this.facilityInfo[facilityCols[i].dataHdngColnm] !== '') {
                                facNm = this.facilityInfo[facilityCols[i].dataHdngColnm];
                            }
                        }
                    }
                }
                if(facNm === '') {
                    for(let i = 0; i < facilityCols.length; i++) {
                        if(facilityCols[i].dataHdngnm === 'FAC_NAME2') {
                            return this.facilityInfo[facilityCols[i].dataHdngColnm];
                        }
                    }
                }
                if(facNm === '') {
                    if(typeof this.facilityInfo.facNm !== $_TYPE.UNDEF) {
                        facNm = this.facilityInfo.facNm;
                    }
                }
                return facNm;
            }
        },
        facilityAddr(){
            let returnAddr = '';
            let facilityCols = this.facilityCols;
            if(typeof facilityCols !== $_TYPE.UNDEF) {
                for(let i = 0; i < facilityCols.length; i++) {
                    if(facilityCols[i].dataHdngnm === 'FAC_ADDR') {
                        returnAddr = this.facilityInfo[facilityCols[i].dataHdngColnm];
                    }
                    if(facilityCols[i].dataHdngnm === 'FAC_ADDR_SUB') {
                        if(typeof this.facilityInfo[facilityCols[i].dataHdngColnm] !== $_TYPE.UNDEF
                            && this.facilityInfo[facilityCols[i].dataHdngColnm] !== '') {
                            returnAddr = returnAddr + " (" + this.facilityInfo[facilityCols[i].dataHdngColnm] +")";
                        }
                    }
                }
            }
            return returnAddr;
        },
        facImgUrl() {
            let returnUrl = '';
            let facilityCols = this.facilityCols;
            if(typeof facilityCols !== $_TYPE.UNDEF) {
                for(let i = 0; i < facilityCols.length; i++) {
                    if(facilityCols[i].dataHdngnm === 'FAC_IMG_URL') {
                        let url = this.facilityInfo[facilityCols[i].dataHdngColnm];
                        if(typeof url !== $_TYPE.UNDEF) {
                            returnUrl = url;
                        }
                    }
                }
            }
            if(typeof this.facilityInfo.dataFiles !== $_TYPE.UNDEF) {
                if(this.facilityInfo.dataFiles.length > 0) {
                    let file = this.facilityInfo.dataFiles[0];
                    returnUrl = $_WC.fileBaseURL + '/image/' + file.comnFlSqno;
                }
            }
            return returnUrl;
        },
        facRegDt() {
            let regDt = '';
            let facilityCols = this.facilityCols;
            if(typeof facilityCols !== 'undefined') {
                for(let i = 0; i < facilityCols.length; i++) {
                    if(facilityCols[i].dataHdngnm === 'FAC_REG_DT') {
                        regDt = this.facilityInfo[facilityCols[i].dataHdngColnm];
                    }
                }
            }
            return regDt;
        },
    },
    updated() {
        this.$emit('loaded-facility-info', this.$el.innerHTML);
    },
    methods: {
        setFacilityInfo(facilityInfo, facilityCols) {
            this.facilityInfo = Object.assign({}, facilityInfo);
            if(typeof facilityCols !== $_TYPE.UNDEF) {
                this.facilityCols = facilityCols;
            } else {
                commonApi.fetchDataKdHdngList(facilityInfo.dataKdSqno)
                    .then((res)=>{
                        this.facilityCols = res.data.data.sort((col1, col2)=>{
                            return (col1.scrnDispSq - col2.scrnDispSq);
                        });
                    });
            }
        },
        showCols(val){
            if(val !== '' && val !== ' ' && val !== '"   "') {
                return true;
            }
            return false;
        },
    },
};
</script>
